import React, { Component, Fragment } from 'react'
 import { OnboardingHeader } from 'components/OnboardingHeader'
 import ProgressMeterWithLogo from 'components/ProgressMeterWithLogo'
 import { Card } from '@drifthq/tide-core'
 import { Emoji } from 'emoji-mart'
 import { track } from 'utils/trackingUtils'
 import BOT_IMG from './chat-bot.svg'
 import LANDING_PAGE_IMG from './landing-page.svg'
 import PURPLE_ARROW from './purple-arrow.svg'
 import { PLAYBOOK_TYPES } from 'layouts/OnboardingPlaybookPickBotStep'
 import OnboardingBackButton from 'components/OnboardingBackButton'
 import { DEMO_REQUEST_STEP_COUNT } from 'flows/OnboardingFlow/constants'
 
import './style.css'
 
class OnboardingPlaybookTargetingStep extends Component {

  onWebsiteClick = () => {
    const { history } = this.props
    history.push('/onboarding/bot')
  }
  
  onLandingPageClick = () => {
    const { history, playbookType, actions } = this.props
    const { createNewsletterPlaybook, createDemoRequestPlaybook } = actions
    if (playbookType === PLAYBOOK_TYPES.NEWSLETTER) {
      createNewsletterPlaybook({
        isLandingPageBot: true
      })
    }

    else if (playbookType === PLAYBOOK_TYPES.DEMO_REQUEST) {
      const { productName, valueProp, industry } = this.props
      createDemoRequestPlaybook({
        isLandingPageBot: true,
        productName: productName,
        valueProp: valueProp,
        industry: industry
      })
    }
    history.push('/onboarding/clp')
  }

  FORM_OPTIONS = Object.freeze([
    {
      title: <div>I want to add this bot<br/>to my website </div>,
      imgSrc: BOT_IMG,
      key: "website-bot",
      clickHandler: this.onWebsiteClick
    },
    {
      title: <div>I want to generate<br/>a custom landing page</div>,
      imgSrc: LANDING_PAGE_IMG,
      key: "landing-page",
      clickHandler: this.onLandingPageClick
    }
  ])

  trackTargetingOption = (targetingType) => {
    const { name, segment } = this.props
    track(`${name} Step - Option Clicked`, { key: targetingType, route: '/playbook/targeting', segment: segment })
    track(`${name} Step - Continued`, { route: '/playbook/targeting', segment: segment })
  }

  onOptionClick = ({ clickHandler, key }) => {
    clickHandler()
    this.trackTargetingOption(key)
  }

  render() {
    const { index, stepCount } = this.props
    return (
      <Fragment>
        <ProgressMeterWithLogo currentLength={index + DEMO_REQUEST_STEP_COUNT} maxLength={stepCount - 1} />
        <OnboardingHeader
          title="Where should this bot show up?"
        />
        <span className="targeting-card-row-with-tip">
          <div className="targeting-card-row">
          {this.FORM_OPTIONS.map(({ title, imgSrc, key, clickHandler }) =>
            <Card
              className="targeting-card"
              imgSrc={imgSrc}
              header={title}
              onClick={() => this.onOptionClick({ clickHandler, key })}
              key={key}/>)
          }
          </div>
          <div className="targeting-tip">
            <img alt="arrow" src={PURPLE_ARROW}/>
            <div className="targeting-tip-copy"> No code necessary <Emoji emoji={"wink"} size={14} /> </div>
          </div>
        </span>
        <OnboardingBackButton />
      </Fragment>
    )
  }
}
 
  export default OnboardingPlaybookTargetingStep 


// WEBPACK FOOTER //
// ./src/layouts/OnboardingPlaybookTargetingStep/index.js